/** Pulsos de luz: el rayo del fondo y los campos reaccionan a la escritura. */
const timers = {};

const flash = (cls, ms) => {
  const el = document.documentElement;
  el.classList.add(cls);
  clearTimeout(timers[cls]);
  timers[cls] = setTimeout(() => el.classList.remove(cls), ms);
};

export const stormPulse = () => flash("storm-pulse", 260);
export const stormSurge = () => flash("storm-surge", 620);

export const pulseField = (el) => {
  if (!el) return;
  el.classList.remove("is-pulsing");
  void el.offsetWidth;
  el.classList.add("is-pulsing");
  stormPulse();
};

export const ripple = (e) => {
  const btn = e.currentTarget;
  const r = btn.getBoundingClientRect();
  const span = document.createElement("span");
  span.className = "glass-ripple";
  span.style.left = `${e.clientX - r.left}px`;
  span.style.top = `${e.clientY - r.top}px`;
  btn.appendChild(span);
  setTimeout(() => span.remove(), 650);
  stormSurge();
};
